import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <section className="min-h-screen flex items-center justify-center pt-20" data-testid="not-found-page">
      <Seo title="Pagina non trovata — Luisa Miceli" description="La pagina cercata non esiste." />
      <div className="text-center px-6">
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-bordeaux">Errore 404</p>
        <h1 className="mt-6 font-serif italic text-5xl sm:text-7xl leading-none">404</h1>
        <p className="mt-6 font-serif text-2xl sm:text-3xl">Questa pagina non esiste.</p>
        <p className="mt-3 text-sm font-light text-ink2 max-w-sm mx-auto">
          Ma il pensiero continua: torna alla home e riparti da lì.
        </p>
        <Link
          to="/"
          className="mt-10 inline-block bg-ink text-paper px-8 py-4 text-[11px] uppercase tracking-[0.25em] transition-colors hover:bg-bordeaux"
          data-testid="not-found-home-link"
        >
          Torna alla home
        </Link>
      </div>
    </section>
  );
}
